import React from 'react';
import Grid from '@material-ui/core/Grid';
import { BankAccount, BankAccountOwnership } from 'stores/workflowStores/finances/bankAccounts/model';
import useGeneralStyles from 'apps/Pdf/styles/general';

interface Props {
  legal?: boolean;
  data: BankAccount[];
}

const BankAccounts = (props: Props) => {
  const styles = useGeneralStyles();
  const { data, legal } = props;

  return (
    <Grid container className={`${styles.lines}`}>
      {data.map((account: BankAccount) => {
        return (
          <Grid item xs={12} key={account.fullNumber}>
            <span className={styles.value}>
              {' '}
              {account.fullNumber} ({account.currency})
            </span>
            <span> - </span>
            {legal ? (
              <>
                <span className={styles.value}>{account.ownerCompanyName}</span>
              </>
            ) : (
              <>
                <span className={styles.value}>
                  {account.ownerFirstname} {account.ownerLastname}
                </span>
                <span> - </span>
                {account.ownership === BankAccountOwnership.CLIENT
                  ? 'čestně prohlašuji, že jsem majitelem účtu'
                  : 'čestně prohlašuji, že je účet součástí SJM'}
              </>
            )}
            {account.primary && (
              <>
                <br />
                <strong>
                  tento účet je primární
                  {account.currency !== 'USD' && (
                    <>, na tento účet se budou vyplácet nastavené cíle v {account.currency === 'CZK' ? 'Kč' : 'Eur'}</>
                  )}
                </strong>
              </>
            )}
          </Grid>
        );
      })}
    </Grid>
  );
};

export default BankAccounts;
